import {useTranslation} from "react-i18next";
import {Select, MenuItem} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import React from "react";

export const SupportedLanguages = (t: (x: string) => string) => {
    return [
        {code: "en", getText: () => t("_Shared.Languages.English")},
        {code: "fr", getText: () => t("_Shared.Languages.French")},
        {code: "it", getText: () => t("_Shared.Languages.Italian")},
        {code: "de", getText: () => t("_Shared.Languages.German")},
        {code: "nl", getText: () => t("_Shared.Languages.Dutch")},
        {code: "es", getText: () => t("_Shared.Languages.Spanish")},
        {code: "pt", getText: () => t("_Shared.Languages.Portuguese")},
        {code: "ja", getText: () => t("_Shared.Languages.Japanese")},
        {code: "da", getText: () => t("_Shared.Languages.Danish")},
        {code: "nb", getText: () => t("_Shared.Languages.Norwegian")},
        {code: "sv", getText: () => t("_Shared.Languages.Swedish")},
    ];
}

export const LanguageSelector = ({name, value, onFormChange, label, error, disabled, helperText, className, ...props}: any) => {
    const {t} = useTranslation();
    const supportedLanguages = SupportedLanguages(t);

    return <FormControl
        disabled={disabled}
        className={className}
        error={error}>
        <InputLabel className={error || helperText ? 'Mui-error' : ''}>{label}</InputLabel>
        <Select
            name={name}
            id={name}
            value={value}
            onChange={onFormChange}
            disabled={disabled}
            className={error || helperText ? 'Mui-error' : ''}
            {...props}
            >
            <MenuItem value={''}></MenuItem>
            {supportedLanguages.map(sl => <MenuItem key={`language-select-item-${sl.code}`} value={sl.code}>{sl.getText()}</MenuItem>)}
        </Select>
        <FormHelperText className={'Mui-error'}>{helperText}</FormHelperText>
    </FormControl>
};
